<template>
  <div>
    <div class="productCardView">

      <div class="productCardView__gallery">
        <PictureGallery :img-list="imgList" :key="triggerKey">
        </PictureGallery>
      </div>
      <div class="productDescription">
        <div class="productDescription__firstText">
          {{item.name}}
           <pre v-show="false">{{item.product_id}}</pre>
        </div>
        <div class="productDescription__header">
          {{item.name}}
        </div>
        <div class="productDescription__price">
          <span class="productDescription__currentPrice">{{ item.sale_price }} Р</span>
          <span class="productDescription__oldPrice" v-if="item.old_price">{{item.old_price}} Р</span>
        </div>
        <div class="productDescription__startRead">{{ item.description }}
        </div>
      <!--  TODO:
        <a href="#" class="productDescription__readNext">Читать дальше</a>
       -->

        <CoinSelect
            :key="coinResetTrigger"
            v-if="isCoin"
            @select-coin="selectedCoinId = $event"
            :product-id="item.product_id"
        ></CoinSelect>


        <div class="productDescription__buy">
          <ActionButton style="background-color: #6FC062; color: #212226;" @buttonClick="addCartExtHandler">
            <template #caption>В корзину</template>
          </ActionButton>
<!-- TODO: feature
          <ActionButton style="">
            <template #caption>Купить в 1 клик</template>
          </ActionButton>
-->
        </div>
        <SpoiledText
            v-if="item.supports_delivery"
            :text="deliveryConditions"
            header="Доставка"
        ></SpoiledText>
        <SpoiledText
            :text="returnRules"
            header="Обмен и возврат"
            :is-bottom="true"
        ></SpoiledText>
      </div>
    </div>
    <br>
    <br>
    <RecommendationsView></RecommendationsView>
  </div>
</template>

<script>
import PictureGallery from "@/components/ui/PictureGallery.vue";
import {computed, onMounted, ref, watch} from "vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import SpoiledText from "@/components/ui/SpoiledText.vue";
import RecommendationsView from "@/components/shared/RecommendationsView.vue";
import {useShopStore} from "@/store/shop";
import {useRoute} from "vue-router";
import {useCartTools} from "@/composables/cart-tools";
import {usePriceItemStore} from "@/store/price-items";
import CoinSelect from "@/components/ProductCardView/CoinSelect.vue";
import environment from "@/environment";
import {useToast} from "vue-toast-notification";

export default {
  name: "ProductCardView",
  components: {CoinSelect, RecommendationsView, SpoiledText, ActionButton, PictureGallery},
  props: ['priceListItemId'],
  setup(props) {

    const route = useRoute();
    const shopStore = useShopStore();
    const cartTools = useCartTools();
    const triggerKey = ref(0);
    const selectedCoinId = ref(null)
    const coinResetTrigger = ref(null)
    const toast = useToast();

    const isCoin = computed(() => {
      return item.value.category_id === environment.appConfig.coinCategory;
    })

    const deliveryConditions = 'При оформлении обучающих семинаров, курсов, интенсивов и лекций - доставка не осуществляется. Доступ происходит через получение покупателем ссылки на цифровой ресурс.\n' +
        '\n' +
        'При оформлении заказов с указанием "самовывоз" покупатель самостоятельно связывается с продавцом и записывается на посещение офиса Клуба для самовывоза заказа.\n' +
        '\n' +
        'Доставка заказов осуществляется продавцом с помощью нескольких сервисов:\n' +
        '1. ПВЗ или постомат СДЭК. Стоимость доставки фиксированная, оплачивается покупателем при оформлении заказа с указанием доставки ПВЗ или постамата СДЭК.\n' +
        '2. Курьерская доставка СДЭК. Стоимость доставки фиксированная, оплачивается покупателем при оформлении заказа с указанием доставки курьером СДЭК.\n' +
        '3. Почта России. Стоимость доставки фиксированная, оплачивается покупателем при оформлении заказа с указанием доставки Почтой России. '

    const returnRules = 'Если по каким-либо причинам Вы решили отказаться от приобретенного товара, то можете сделать это в соответствии с Законом РФ «О защите прав потребителей» от 07.02.1992 № 2300-1.\n' +
        '\n' +
        'Возврат товара возможен при соблюдении следующих условий:\n' +
        '\n' +
        'Возврат товара надлежащего качества.\n' +
        'Клиент вправе отказаться от заказанного Товара в любое время до его получения, а после получения Товара - в течение 30 (тридцати) дней, не считая дня покупки.\n' +
        'Возврат Товара надлежащего качества возможен в случае, если сохранены его товарный вид, потребительские свойства, а также документ, подтверждающий факт и условия покупки указанного Товара.\n' +
        'Клиент не вправе отказаться от Товара, имеющего индивидуально-определенные свойства, если указанный Товар может быть использован исключительно приобретающим его Клиентом.\n' +
        'При отказе Клиента от Товара надлежащего качества Продавец должен возвратить ему денежную сумму, уплаченную потребителем по договору, за исключением расходов продавца на доставку от потребителя возвращенного товара, не позднее чем через 10 дней со дня предъявления потребителем соответствующего требования.\n' +
        '\n' +
        'Возврат товара ненадлежащего качества\n' +
        'Под товаром ненадлежащего качества подразумевается товар, не способный обеспечить свои функциональные качества из-за существенного недостатка (с наличием дефектов/брака).\n' +
        '\n' +
        'Покупатель, которому продан товар ненадлежащего качества, если это не было оговорено продавцом, вправе по своему выбору заявить любое из нижеперечисленных требований:\n' +
        ' - замены на товар аналогичной марки (модели, артикула) или на такой же товар другой марки (модели, артикула) с соответствующим перерасчетом покупной цены;\n' +
        ' - соразмерного уменьшения покупной цены;\n' +
        ' - безвозмездного устранения недостатков товара или возмещения расходов на их исправление покупателем или третьим лицом;\n' +
        ' - вправе отказаться от исполнения договора и потребовать возврата уплаченной за товар суммы.\n' +
        '\n' +
        'При возврате технически сложного товара ненадлежащего качества (перечень таких товаров утвержден Постановлением Правительства РФ от 10.11.2011 № 924 «Об утверждении перечня технически сложных товаров») Покупатель имеет право потребовать:\n' +
        ' - замены на товар аналогичной марки (модели, артикула) или на такой же товар другой марки (модели, артикула) с соответствующим перерасчетом покупной цены;\n' +
        ' - отказаться от исполнения договора и потребовать возврата уплаченной за товар суммы.\n' +
        'Все вышеперечисленные требования по возврату товара ненадлежащего качества могут быть предъявлены в следующие сроки:\n' +
        'На товар установлен гарантийный срок — в течение всего гарантийного срока;\n' +
        'На товар не установлен гарантийный срок — в течение одного календарного года\n' +
        'Интернет-магазин вправе отказать в обмене или возврате товара, если сочтет, что обнаруженный существенный недостаток является следствием неправильной эксплуатации товара.\n' +
        '\n' +
        'В случае возникновения разногласий по качеству или причинам возникновения недостатков, Интернет-магазин вправе провести независимую экспертизу за свой счет. Покупатель может участвовать в экспертизе и оспорить ее решение в суде. Если в результате экспертизы установлено, что недостатки товара возникли по вине Покупателя, то Покупатель обязан возместить Интернет-магазину стоимость экспертизы, а также связанные с ее проведением расходы на транспортировку и хранение товара'
    async function addCartExtHandler() {

      if(item.value.category_id === environment.appConfig.coinCategory &&  !selectedCoinId.value){
        toast.error("Не выбрана монета");
        return;
      }

      const r  = await cartTools.addCartHandler(item.value, selectedCoinId.value);
      if(r && selectedCoinId.value) {
        coinResetTrigger.value = coinResetTrigger.value + 1;
      }
    }

    function clearData() {
      shopStore.clearData();
    }
    shopStore.setRecord({})
    const priceItemStore = usePriceItemStore()

    const item = computed(() => {
      return shopStore.record;
    })

    const imgList = computed(() => {
      const res = [
        item.value.img_url,
        item.value.img_url1,
        item.value.img_url2,
        item.value.img_url3,
        item.value.img_url4
      ];
      return res.filter(item => item);
    })

    function fillData() {
      shopStore.loadPriceItem({price_list_item_id: props.priceListItemId});
      priceItemStore.loadTopPriceItems();
    }

    onMounted(() => {
     fillData();
    })

    watch(() => route.query, () => {
      clearData();
      triggerKey.value++;
      fillData();
    }, { deep: true });


    return {
      imgList,
      item,
      addCartHandler: cartTools.addCartHandler,
      clearData,
      triggerKey,
      isCoin,
      selectedCoinId,
      addCartExtHandler,
      coinResetTrigger,
      deliveryConditions,
      returnRules
    }
  }
}
</script>


<style scoped lang="scss">
.productCardView {
  text-align: left;
  display: flex;
  gap: 24px;
  align-items: flex-start;

  @include respond-to('md') {
    flex-direction: column;
  }

  &__gallery {
    width: 49%;
    flex-shrink: 0;

    @include respond-to('md') {
      width: 100%;
    }
  }
}

.productDescription {
  flex: 1 1 0;
  min-width: 0;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @include respond-to('md') {
    width: 100%;
  }

  &__firstText {
    font-family: var(--cd-default-font);
    font-size: 14px;
    font-weight: var(--cd-default-font-weight);
  }

  &__header {
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: clamp(24px, 4vw, 38px);
    color: var(--cd-highlight-text);
  }

  &__price {
    display: flex;
    gap: 16px;
    font-family: var(--cd-default-font);
    font-weight: 400;
    font-size: clamp(18px, 3vw, 26px);
  }

  &__currentPrice {
    color: var(--cd-highlight-text);
  }

  &__oldPrice {
    color: var(--cd-text-muted);
    text-decoration: line-through;
  }

  &__buy {
    display: flex;
    gap: 8px;
    margin: 16px 0;
  }

  button {
    width: 140px;
  }

  &__startRead {
    font-family: var(--cd-default-font);
    background: linear-gradient(181.51deg,
        rgba(255, 255, 255, 0.77) 8.4%,
        rgba(226, 226, 226, 0.77) 63.96%,
        rgba(153, 153, 153, 0.77) 91.31%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
  }
}

.productDescription__readNext {
  font-family: var(--cd-default-font);
  color: var(--cd-green);
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}
</style>
